import React from "react";
import { Row, Col } from "react-bootstrap";
import Skeleton from "@mui/material/Skeleton";

const ShopSkeletonCard = () => {
  return (
    <div className="col-12 col-sm-6 col-md-6 col-lg-4 col-xl-3 p-2">
      <div className="ShopsCards mt-2 mb-2">
        <div className="fix-img position-relative">
          <Skeleton variant="rectangular" width="100%" height={180} />
        </div>
        <div className="border">
          <div>
            <Row className="align-items-center pt-2">
              <Col>
                <Skeleton variant="text" width="80%" height={24} sx={{ ml: 1 }} />
              </Col>
              <Col>
                <Skeleton variant="text" width="60%" height={20} sx={{ mr: 1, float: "right" }} />
              </Col>
            </Row>
            <Row className="ps-2 ">
              <Col lg={6} className="ps-1 pe-0">
                <Skeleton variant="text" width="40%" height={24} sx={{ ml: 1 }} />
              </Col>
              <Col lg={6} className="p-0 text-center mt-1">
                <Skeleton variant="text" width="30%" height={20} sx={{ ml: "auto", mr: 1 }} />
              </Col>
            </Row>
          </div>
          <div className="d-flex justify-content-around pt-1 pb-1 mb-1 mt-1">
             <Skeleton variant="rounded" width={80} height={30} />
          </div>
          <div className="margin-Boxes">
            <Row className="row bg-blue m-0 shop-item-contact-actions">
              <Col lg={6} md={4} className="p-0">
                <div className="border-end d-flex justify-content-center align-items-center p-1" style={{height: "36px"}}>
                   <Skeleton variant="text" width="60%" height={20} sx={{ bgcolor: 'rgba(255,255,255,0.3)' }} />
                </div>
              </Col>
              <Col lg={6} md={4} className="p-0">
                <div className="d-flex justify-content-center align-items-center p-1" style={{height: "36px"}}>
                   <Skeleton variant="text" width="60%" height={20} sx={{ bgcolor: 'rgba(255,255,255,0.3)' }} />
                </div>
              </Col>
            </Row>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ShopSkeletonCard;
